import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * Persisted to localStorage so the active workspace survives page refresh
 */
export const activeWorkspaceIdAtom = atomWithStorage<null | string>(
  'clew-active-workspace',
  null,
);

/**
 * Currently selected process in the process list. Not persisted — resets on refresh.
 */
export const selectedProcessIdAtom = atom<null | string>(null);

/**
 * Controls the timeline drawer open/close state
 */
export const timelineExpandedAtom = atom(false);
